interface Props {
  yield_: number | null | undefined;
  exDate?: string | null;
}

/** Compact yield chip. yfinance reports yield as a fraction (0.0234 = 2.34%). */
export default function DividendBadge({ yield_, exDate }: Props) {
  if (yield_ === null || yield_ === undefined || yield_ <= 0) return null;
  const pct = yield_ * 100;
  const tooltip = exDate
    ? `${pct.toFixed(2)}% annual yield · ex-div ${exDate}`
    : `${pct.toFixed(2)}% annual yield`;
  return (
    <span
      title={tooltip}
      className="inline-flex items-center rounded-full bg-amber-500/10 px-1.5 py-0.5 text-[10px] font-semibold tabular-nums text-amber-300 ring-1 ring-inset ring-amber-500/30"
    >
      {pct.toFixed(2)}% div
    </span>
  );
}
